// mockManagerData.js
// Phase 1 mock data for the Training Admin dashboard.
// Replace API calls with real backend endpoints in Phase 2.

// ── Admin user types ──────────────────────────────────────────────────────────
export const ADMIN_TYPES = {
  TRAINING_ACADEMY: 'training_academy',
  COMPLIANCE: 'compliance',
  HR: 'hr',
  OPERATIONS: 'operations',
  SALES: 'sales',
};

// Which categories each admin type can manage
export const ADMIN_CATEGORY_SCOPE = {
  training_academy: null,         // null = all categories
  compliance: ['Compliance'],
  hr: ['Professional Skills', 'Leadership'],
  operations: ['Operations'],
  sales: ['Sales'],
};

// ── Departments / categories ──────────────────────────────────────────────────
export const DEPARTMENTS = [
  { id: 'compliance', label: 'Compliance', color: '#752F87' },
  { id: 'products', label: 'Products', color: '#2563EB' },
  { id: 'sales', label: 'Sales', color: '#DC2626' },
  { id: 'operations', label: 'Operations', color: '#D97706' },
  { id: 'digital', label: 'Digital', color: '#059669' },
  { id: 'professional_skills', label: 'Professional Skills', color: '#7C3AED' },
  { id: 'leadership', label: 'Leadership', color: '#0891B2' },
  { id: 'customer_service', label: 'Customer Service', color: '#BE185D' },
];

// ── Branches ──────────────────────────────────────────────────────────────────
export const BRANCHES = [
  { id: 'accra', label: 'Accra Main' },
  { id: 'kumasi', label: 'Kumasi' },
  { id: 'tamale', label: 'Tamale' },
  { id: 'takoradi', label: 'Takoradi' },
  { id: 'cape_coast', label: 'Cape Coast' },
  { id: 'sunyani', label: 'Sunyani' },
];

// ── Roles ─────────────────────────────────────────────────────────────────────
export const AGENT_ROLES = [
  { id: 'agent', label: 'Sales Agent' },
  { id: 'team-leader', label: 'Team Leader' },
  { id: 'supervisor', label: 'Supervisor' },
  { id: 'telesales', label: 'Telesales' },
  { id: 'all', label: 'All Staff' },
];

// ── Mock agents (team members) ────────────────────────────────────────────────
export const mockAgents = [
  { id: 'a001', name: 'Kwame Asante', email: 'k.asante@starlife.com.gh', role: 'agent', branch: 'accra', avatar: null },
  { id: 'a002', name: 'Abena Mensah', email: 'a.mensah@starlife.com.gh', role: 'agent', branch: 'accra', avatar: null },
  { id: 'a003', name: 'Kofi Osei', email: 'k.osei@starlife.com.gh', role: 'team-leader', branch: 'kumasi', avatar: null },
  { id: 'a004', name: 'Ama Boateng', email: 'a.boateng@starlife.com.gh', role: 'agent', branch: 'kumasi', avatar: null },
  { id: 'a005', name: 'Yaw Darko', email: 'y.darko@starlife.com.gh', role: 'agent', branch: 'tamale', avatar: null },
  { id: 'a006', name: 'Akosua Frimpong', email: 'a.frimpong@starlife.com.gh', role: 'supervisor', branch: 'accra', avatar: null },
  { id: 'a007', name: 'Nana Agyeman', email: 'n.agyeman@starlife.com.gh', role: 'agent', branch: 'takoradi', avatar: null },
  { id: 'a008', name: 'Efua Quaye', email: 'e.quaye@starlife.com.gh', role: 'telesales', branch: 'accra', avatar: null },
  { id: 'a009', name: 'Kwabena Poku', email: 'k.poku@starlife.com.gh', role: 'agent', branch: 'cape_coast', avatar: null },
  { id: 'a010', name: 'Adwoa Sarpong', email: 'a.sarpong@starlife.com.gh', role: 'agent', branch: 'sunyani', avatar: null },
  { id: 'a011', name: 'Fiifi Annan', email: 'f.annan@starlife.com.gh', role: 'agent', branch: 'accra', avatar: null },
  { id: 'a012', name: 'Maame Kyei', email: 'm.kyei@starlife.com.gh', role: 'agent', branch: 'kumasi', avatar: null },
];

// ── Mock courses (admin view — includes published status) ─────────────────────
export const mockAdminCourses = [
  {
    id: 'course-product-compliance',
    title: 'Product Knowledge & Compliance',
    category: 'Compliance',
    color: '#752F87',
    status: 'published',
    mandatory: true,
    assignedTo: ['all'],
    enrolledCount: 12,
    completedCount: 7,
    passCount: 6,
    failCount: 1,
    avgScore: 74,
    deadline: new Date(Date.now() + 3 * 24 * 3600 * 1000).toISOString(),
    createdBy: 'Training Academy',
    estimatedMinutes: 45,
    moduleCount: 3,
  },
  {
    id: 'course-aml-foundation',
    title: 'AML & Financial Crime Basics',
    category: 'Compliance',
    color: '#752F87',
    status: 'published',
    mandatory: true,
    assignedTo: ['all'],
    enrolledCount: 12,
    completedCount: 5,
    passCount: 4,
    failCount: 1,
    avgScore: 71,
    deadline: new Date(Date.now() + 7 * 24 * 3600 * 1000).toISOString(),
    createdBy: 'Compliance',
    estimatedMinutes: 40,
    moduleCount: 2,
  },
  {
    id: 'course-customer-experience',
    title: 'Customer Experience Excellence',
    category: 'Customer Service',
    color: '#BE185D',
    status: 'published',
    mandatory: false,
    assignedTo: ['agent', 'telesales'],
    enrolledCount: 8,
    completedCount: 3,
    passCount: 3,
    failCount: 0,
    avgScore: 82,
    deadline: new Date(Date.now() + 14 * 24 * 3600 * 1000).toISOString(),
    createdBy: 'Training Academy',
    estimatedMinutes: 35,
    moduleCount: 2,
  },
  {
    id: 'course-life-insurance-products',
    title: 'StarLife Product Suite Overview',
    category: 'Products',
    color: '#2563EB',
    status: 'published',
    mandatory: false,
    assignedTo: ['agent'],
    enrolledCount: 10,
    completedCount: 4,
    passCount: 4,
    failCount: 0,
    avgScore: 78,
    deadline: new Date(Date.now() + 14 * 24 * 3600 * 1000).toISOString(),
    createdBy: 'Training Academy',
    estimatedMinutes: 60,
    moduleCount: 2,
  },
  {
    id: 'course-pension-products',
    title: 'Pension & Retirement Planning',
    category: 'Products',
    color: '#0891B2',
    status: 'draft',
    mandatory: false,
    assignedTo: [],
    enrolledCount: 0,
    completedCount: 0,
    passCount: 0,
    failCount: 0,
    avgScore: 0,
    deadline: null,
    createdBy: 'Training Academy',
    estimatedMinutes: 50,
    moduleCount: 2,
  },
];

// ── Mock agent progress (per course per agent) ────────────────────────────────
// Shape: { agentId, courseId, status, progressPct, examScore, examPassed, lastActivity }
export const mockAgentProgress = [
  // course-product-compliance
  { agentId: 'a001', courseId: 'course-product-compliance', status: 'completed', progressPct: 100, examScore: 80, examPassed: true, lastActivity: new Date(Date.now() - 2 * 24 * 3600 * 1000).toISOString() },
  { agentId: 'a002', courseId: 'course-product-compliance', status: 'completed', progressPct: 100, examScore: 72, examPassed: true, lastActivity: new Date(Date.now() - 1 * 24 * 3600 * 1000).toISOString() },
  { agentId: 'a003', courseId: 'course-product-compliance', status: 'completed', progressPct: 100, examScore: 65, examPassed: false, lastActivity: new Date(Date.now() - 3 * 24 * 3600 * 1000).toISOString() },
  { agentId: 'a004', courseId: 'course-product-compliance', status: 'in_progress', progressPct: 60, examScore: null, examPassed: null, lastActivity: new Date(Date.now() - 1 * 24 * 3600 * 1000).toISOString() },
  { agentId: 'a005', courseId: 'course-product-compliance', status: 'in_progress', progressPct: 30, examScore: null, examPassed: null, lastActivity: new Date(Date.now() - 4 * 24 * 3600 * 1000).toISOString() },
  { agentId: 'a006', courseId: 'course-product-compliance', status: 'completed', progressPct: 100, examScore: 90, examPassed: true, lastActivity: new Date(Date.now() - 5 * 24 * 3600 * 1000).toISOString() },
  { agentId: 'a007', courseId: 'course-product-compliance', status: 'not_started', progressPct: 0, examScore: null, examPassed: null, lastActivity: null },
  { agentId: 'a008', courseId: 'course-product-compliance', status: 'completed', progressPct: 100, examScore: 75, examPassed: true, lastActivity: new Date(Date.now() - 2 * 24 * 3600 * 1000).toISOString() },
  { agentId: 'a009', courseId: 'course-product-compliance', status: 'not_started', progressPct: 0, examScore: null, examPassed: null, lastActivity: null },
  { agentId: 'a010', courseId: 'course-product-compliance', status: 'in_progress', progressPct: 80, examScore: null, examPassed: null, lastActivity: new Date(Date.now() - 1 * 24 * 3600 * 1000).toISOString() },
  { agentId: 'a011', courseId: 'course-product-compliance', status: 'completed', progressPct: 100, examScore: 68, examPassed: false, lastActivity: new Date(Date.now() - 6 * 24 * 3600 * 1000).toISOString() },
  { agentId: 'a012', courseId: 'course-product-compliance', status: 'not_started', progressPct: 0, examScore: null, examPassed: null, lastActivity: null },
  // course-aml-foundation
  { agentId: 'a001', courseId: 'course-aml-foundation', status: 'completed', progressPct: 100, examScore: 85, examPassed: true, lastActivity: new Date(Date.now() - 5 * 24 * 3600 * 1000).toISOString() },
  { agentId: 'a002', courseId: 'course-aml-foundation', status: 'completed', progressPct: 100, examScore: 78, examPassed: true, lastActivity: new Date(Date.now() - 4 * 24 * 3600 * 1000).toISOString() },
  { agentId: 'a003', courseId: 'course-aml-foundation', status: 'in_progress', progressPct: 50, examScore: null, examPassed: null, lastActivity: new Date(Date.now() - 2 * 24 * 3600 * 1000).toISOString() },
  { agentId: 'a004', courseId: 'course-aml-foundation', status: 'completed', progressPct: 100, examScore: 60, examPassed: false, lastActivity: new Date(Date.now() - 3 * 24 * 3600 * 1000).toISOString() },
  { agentId: 'a005', courseId: 'course-aml-foundation', status: 'not_started', progressPct: 0, examScore: null, examPassed: null, lastActivity: null },
  { agentId: 'a006', courseId: 'course-aml-foundation', status: 'completed', progressPct: 100, examScore: 92, examPassed: true, lastActivity: new Date(Date.now() - 7 * 24 * 3600 * 1000).toISOString() },
  { agentId: 'a007', courseId: 'course-aml-foundation', status: 'not_started', progressPct: 0, examScore: null, examPassed: null, lastActivity: null },
  { agentId: 'a008', courseId: 'course-aml-foundation', status: 'not_started', progressPct: 0, examScore: null, examPassed: null, lastActivity: null },
  { agentId: 'a009', courseId: 'course-aml-foundation', status: 'in_progress', progressPct: 70, examScore: null, examPassed: null, lastActivity: new Date(Date.now() - 1 * 24 * 3600 * 1000).toISOString() },
  { agentId: 'a010', courseId: 'course-aml-foundation', status: 'not_started', progressPct: 0, examScore: null, examPassed: null, lastActivity: null },
  { agentId: 'a011', courseId: 'course-aml-foundation', status: 'not_started', progressPct: 0, examScore: null, examPassed: null, lastActivity: null },
  { agentId: 'a012', courseId: 'course-aml-foundation', status: 'completed', progressPct: 100, examScore: 74, examPassed: true, lastActivity: new Date(Date.now() - 2 * 24 * 3600 * 1000).toISOString() },
];

// ── Mock org-wide weekly activity ─────────────────────────────────────────────
export const mockOrgWeeklyActivity = [
  { day: 'Mon', completions: 4, logins: 8 },
  { day: 'Tue', completions: 7, logins: 11 },
  { day: 'Wed', completions: 3, logins: 6 },
  { day: 'Thu', completions: 9, logins: 14 },
  { day: 'Fri', completions: 6, logins: 10 },
  { day: 'Sat', completions: 1, logins: 2 },
  { day: 'Sun', completions: 0, logins: 0 },
];

// ── Mock recent admin activity log ────────────────────────────────────────────
export const mockActivityLog = [
  { id: 1, type: 'completion', agentName: 'Kwame Asante', courseTitle: 'Product Knowledge & Compliance', score: 80, timestamp: new Date(Date.now() - 2 * 3600 * 1000).toISOString() },
  { id: 2, type: 'fail', agentName: 'Kofi Osei', courseTitle: 'Product Knowledge & Compliance', score: 65, timestamp: new Date(Date.now() - 5 * 3600 * 1000).toISOString() },
  { id: 3, type: 'enrolled', agentName: 'Adwoa Sarpong', courseTitle: 'AML & Financial Crime Basics', score: null, timestamp: new Date(Date.now() - 8 * 3600 * 1000).toISOString() },
  { id: 4, type: 'completion', agentName: 'Abena Mensah', courseTitle: 'AML & Financial Crime Basics', score: 78, timestamp: new Date(Date.now() - 12 * 3600 * 1000).toISOString() },
  { id: 5, type: 'overdue', agentName: 'Nana Agyeman', courseTitle: 'Product Knowledge & Compliance', score: null, timestamp: new Date(Date.now() - 18 * 3600 * 1000).toISOString() },
  { id: 6, type: 'completion', agentName: 'Akosua Frimpong', courseTitle: 'AML & Financial Crime Basics', score: 92, timestamp: new Date(Date.now() - 24 * 3600 * 1000).toISOString() },
];
